module.exports = {
  breakNode: require('./break_node'),
  copySelection: require('./copy_selection'),
  deleteCharacter: require('./delete_character'),
  deleteNode: require('./delete_node'),
  deleteSelection: require('./delete_selection'),
  insertNode: require('./insert_node'),
  insertText: require('./insert_text'),
  merge: require('./merge'),
  paste: require('./paste'),
  switchTextType: require('./switch_text_type'),
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/document/transformations/index.js
 ** module id = 149
 ** module chunks = 0
 **/